import moment from "moment";
import { FieldGroupIcon, Flex, TextField } from "@aws-amplify/ui-react";
import CalendarIcon from "@mui/icons-material/CalendarMonth";
import CancelIcon from "@mui/icons-material/Close";

const DateRangeInput = ({ name, label, start, end, onClick, onClear }) => (
  <TextField
    name={name}
    label={label}
    value={
      start &&
      `${moment(start).format("YYYY/MM/DD")} - ${moment(end).format(
        "YYYY/MM/DD"
      )}`
    }
    isReadOnly
    onClick={onClick}
    innerEndComponent={
      <FieldGroupIcon ariaLabel="">
        <Flex alignItems="center" gap={5}>
          <CalendarIcon />
          {start && (
            <CancelIcon
              onClick={onClear}
              style={{ pointerEvents: "all" }}
              fontSize="small"
              color="action"
            />
          )}
        </Flex>
      </FieldGroupIcon>
    }
  ></TextField>
);

export default DateRangeInput;
